<div class="login">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6 logo-holder">
                <div class="login-img">
                    <img class="logo mb-4" src="assets/logo.png">
                    <img class="buildings" src="assets/clipart-building.png" alt="">
                </div>
            </div>
            <div class="col-md-6 col-sm-12">
                <mat-tab-group mat-align-tabs="center" [(selectedIndex)]="selectedIndex" (selectedIndexChange)="changeRoute()">
                    <mat-tab>
                      <ng-template mat-tab-label>
                        <mat-icon class="example-tab-icon mr-2">login</mat-icon>
                        Login
                      </ng-template>
                      <app-login></app-login>
                    </mat-tab>
                  
                    <mat-tab>
                      <ng-template mat-tab-label>
                        <mat-icon class="example-tab-icon mr-2">how_to_reg</mat-icon>
                        Signup
                      </ng-template>
                      <app-register></app-register>
                    </mat-tab>
                  </mat-tab-group>
            </div>
        </div>
    </div>
</div>